import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

export const lobbyTab = createTab({
  slides: [
    {
      ...createDescription([
        'Просторные, светлые лобби с высокими потолками',
        'и дизайнерским интерьером ежедневно встречают жителей в',
        'кварталах «Серии плюс».',
      ]),
      imageAlt: 'Современное лобби с высокими потолками в квартале Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/modern-lobby/1.webp`,
      markers: createSlideMarkers([
        {
          left: 693,
          tooltip: { placement: 'right', text: 'Витражное остекление' },
          top: 458,
        },
        {
          left: 900,
          tooltip: { placement: 'right', text: 'Акцентная подсветка' },
          top: 394,
        },
        {
          left: 781,
          tooltip: { placement: 'top-start', text: 'Зона ожидания' },
          top: 837,
        },
      ]),
    },
    {
      ...createDescription([
        'Для хранения велосипедов и детских колясок предусмотрена специальная',
        'зона, куда нет доступа посторонним. После прогулки просто оставьте их',
        'там и поднимайтесь в квартиру без лишних забот.',
      ]),
      imageAlt: 'Зона хранения велосипедов и колясок в лобби Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/modern-lobby/2.webp`,
      markers: createSlideMarkers([
        {
          left: 331,
          tooltip: { placement: 'right', text: 'Крепления для вертикального хранения' },
          top: 294,
        },
        {
          left: 1251,
          tooltip: { placement: 'bottom', text: 'Вход по электронному ключу жителя' },
          top: 407,
        },
      ]),
    },
    {
      ...createDescription([
        'Поездка будет максимально комфортной: двери работают тихо, кабина движется плавно благодаря',
        'высококачественным приводам и виброизоляции. А пожаробезопасные материалы и комплекс из пяти',
        'страховочных механизмов гарантируют безопасность.',
      ]),
      imageAlt: 'Лифт и навигация в лобби Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/modern-lobby/3.webp`,
      markers: createSlideMarkers([
        {
          left: 1012,
          tooltip: { placement: 'right', text: 'Навигация' },
          top: 356,
        },
        {
          left: 640,
          tooltip: { placement: 'right', text: 'Быстрые и тихие лифты' },
          top: 477,
        },
      ]),
    },
    {
      ...createDescription([
        'Гостевой санузел — удобное и функциональное пространство. Больше',
        'не нужно подниматься в квартиру, чтобы вымыть руки после прогулки',
        'с ребёнком, — всё предусмотрено для вашего комфорта.',
      ]),
      imageAlt: 'Гостевой санузел в лобби Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/modern-lobby/4.webp`,
      markers: createSlideMarkers([
        {
          left: 755,
          tooltip: { placement: 'right-start', text: 'Выход в закрытый двор-парк' },
          top: 385,
        },
        {
          left: 1396,
          tooltip: { placement: 'left', text: 'Гостевой санузел' },
          top: 399,
        },
      ]),
    },
    {
      ...createDescription([
        'Современный межквартирный коридор создаёт ощущение уюта.',
        'Доступ к коммуникациям вынесен в коридор.',
      ]),
      imageAlt: 'Межквартирный коридор в доме Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/modern-lobby/5.webp`,
      markers: createSlideMarkers([
        {
          left: 301,
          tooltip: { placement: 'right-start', text: 'Потолок из металлических кассет' },
          top: 246,
        },
        {
          left: 656,
          tooltip: { placement: 'right-start', text: 'Доступ к счетчикам и кранам из коридора' },
          top: 294,
        },
        {
          left: 906,
          tooltip: { placement: 'right-start', text: 'Дверь с дополнительным контуром уплотнения' },
          top: 305,
        },
        {
          left: 1076,
          tooltip: { placement: 'right-start', text: 'Фактурная штукатурка' },
          top: 567,
        },
      ]),
    },
  ],
  title: 'Современное лобби',
});
